import { Navigate } from "react-router-dom";
import RequireAdmin from "./RequireAdmin";
import usePresenceAccess from "./presence/usePresenceAccess";
import { isAdmin } from "../utils/permissions";
import useAuth from "../hooks/useAuth";

/**
 * Team Presence guard: admins (high_potit) and squad leads. Everything else is
 * redirected to the unauthorized page. Admins skip the API check.
 */
const RequirePresenceAccess = ({ children }) => {
  const { auth } = useAuth();
  const admin = isAdmin(auth?.employee);
  const { access, loading } = usePresenceAccess(!admin);
  if (admin) return <RequireAdmin>{children}</RequireAdmin>;
  if (loading) return null;
  return access?.isLead ? children : <Navigate to="/unauthorized" replace />;
};

export default RequirePresenceAccess;
